import shortsModal from './js/shorts.js';

window.shortsModal = shortsModal;
